/******************************************************************************************
 *	Format Month Filter
 *******************************************************************************************
 *
 * Takes a date and outputs the month and year in the defined, translated format. Overrides the
 * month translations for certain languages to use correct declensions, which were incorrect using
 * the angular locale month translation defaults.
 *
 */
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular
    .module('rcFilters.formatMonth', [])
    .constant('MONTHS_LOCALIZED', {
      'cs-cz': 'leden,únor,březen,duben,květen,červen,červenec,srpen,září,říjen,listopad,prosinec',
      'fi-fi':
        'tammikuu,helmikuu,maaliskuu,huhtikuu,toukokuu,kesäkuu,heinäkuu,elokuu,syyskuu,lokakuu,marraskuu,joulukuu',
      'pl-pl':
        'styczeń,luty,marzec,kwiecień,maj,czerwiec,lipiec,sierpień,wrzesień,październik,listopad,grudzień',
      'ru-ru': 'январь,февраль,март,апрель,май,июнь,июль,август,сентябрь,октябрь,ноябрь,декабрь'
    })
    .filter(
      'formatMonth',
      /* @ngInject */
      function(_, $filter, $locale, MONTHS_LOCALIZED) {
        return function(date) {
          var dateObj;
          if (_.isString(date)) {
            dateObj = new Date(date);
          } else if (_.isDate(date)) {
            dateObj = date;
          } else if (date && date.hasOwnProperty('date')) {
            dateObj = date.date;
          } else {
            return '';
          }
          var originalMonths = $locale.DATETIME_FORMATS.MONTH;

          // using correct declensions for months drop-down
          if (MONTHS_LOCALIZED[$locale.id]) {
            $locale.DATETIME_FORMATS.MONTH = _.split(MONTHS_LOCALIZED[$locale.id], ',');
          }

          var result = $filter('date')(dateObj, $filter('translate')('date.format_month'));

          $locale.DATETIME_FORMATS.MONTH = originalMonths;
          return result;
        };
      }
    );
})();
